import json from "./spritesheet";

const sizeList = {
  "1": "thin",
  "2": "middle",
  "3": "fat"
};

const sizeRatio = 0.5;
const posRandom = 0.05;
const sizeRandom = 0.1;
const thresholdAmp = 0.1;
const sizeAmp2 = [0.35, 0.405, .45];

export default class SprayTool {
  constructor() {
    this.sprite = this.load("/img/sprays.png");
  }
  onload(e) {
    console.log("onload spray", e);
  }

  draw(context, lastPos, pos, color, penSize, alpha, scale = 1) {
    // let color = Math.floor(Math.random() * 7 + 1);
    color++;

    scale *= sizeAmp2[penSize - 1];

    const name = `${color}-${sizeList["" + penSize]}.png`;
    let data = json.frames[name];
    const srcSize = data.sourceSize.w;

    const distance = this.getDistance(lastPos, pos);
    // ひろすぎたらforでまわす
    if (distance > srcSize * sizeRatio * thresholdAmp) {
      // const dx = distance / size;
      const dx = ((srcSize * sizeRatio) / distance) * 0.7;
      let per = 0;
      let diff = {
        x: pos.x - lastPos.x,
        y: pos.y - lastPos.y
      };
      while (per < 1) {
        const size = this.getSize(srcSize, scale);
        let dp2 = {
          x: diff.x * per + lastPos.x,
          y: diff.y * per + lastPos.y
        };
        this.draw2(context, data.frame, dp2, srcSize, size, alpha);
        per += dx;
      }
    } else {
      const size = this.getSize(srcSize, scale);
      this.draw2(context, data.frame, pos, srcSize, size, alpha);
    }
  }

  draw2(context, frame, pos, srcSize, size, alpha = 0.2) {
    const halfSize = size * 0.5;
    const posFix = {
      x: pos.x + (Math.random() - 0.5) * halfSize * posRandom,
      y: pos.y + (Math.random() - 0.5) * halfSize * posRandom
    };
    context.globalAlpha = alpha;
    // context.globalCompositeOperation = "soft-light";
    context.drawImage(
      this.sprite,
      frame.x,
      frame.y,
      srcSize,
      srcSize,
      posFix.x - halfSize,
      posFix.y - halfSize,
      size,
      size
    );
    context.globalAlpha = 1;
  }

  load(src) {
    const img = new Image();
    img.src = src;
    // this.fat.addEventListener("load", this.onload, false);
    return img;
  }

  getDistance(lastPos, pos) {
    const deltaX = lastPos.x - pos.x;
    const deltaY = lastPos.y - pos.y;
    return deltaX * deltaX + deltaY * deltaY;
  }

  getSize(srcSize, scale = 1) {
    return srcSize * sizeRatio * scale + (Math.random() - 0.5) * srcSize * sizeRatio * sizeRandom * scale;
  }
}
